document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.card__media');
  let currentActive = null;

  cards.forEach(function (card) {
    const hasSecondImage = card.querySelectorAll('.media--hover-effect img').length > 1;
    if (!hasSecondImage) return;

    card.addEventListener('mouseenter', function () {
      if (currentActive && currentActive !== card) {
        currentActive.classList.remove('is-active');
      }
      card.classList.add('is-active');
      currentActive = card;
    });
  });
});